import axios from 'axios'
import { captureException as SentryCaptureException } from '@sentry/browser'
import router from '../router'

export const apiClient = () => {
    const _axios = axios.create({
        baseURL: process.env.VUE_APP_API_ENDPOINT,
        withCredentials: false,
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': localStorage.getItem('auth-token'),
        },
    });

    _axios.interceptors.response.use(function (response) {
        return response;
    }, function (error) {
        if (error.response.status === 401 && router.currentRoute.meta.isSecured) {
            localStorage.removeItem('auth-token');
            router.replace({ name: 'signIn' });
        } else if (parseInt((error.response.status + '').charAt(0)) === 5) {
            // catch server error
            SentryCaptureException(error);
        }
        return Promise.reject(error);
    });

    return _axios;
};
